<template>
    <div class="visitor-system">
      <div class="background-image">
        <img class="top-image" src="@/assets/di.png" alt="Top Image" />
        <span class="welcome-text">帮访客</span>
        <span class="dengji">填写信息</span>
        <img class="top-top-image" src="@/assets/image.png" alt="Bottom Image" />
      </div>
      <div class="visitor-form">
        <div class="form-group">
          <label class="label">访客姓名</label>
          <input class="info editable" type="text" placeholder="请输入访客姓名" v-model="form.name" />
        </div>
        <div class="form-group">
          <label class="label">访客手机号</label>
          <input class="info editable" type="tel" placeholder="请输入访客手机号" v-model="form.phone" />
        </div>
        <div class="form-group">
          <label class="label">访客单位</label>
          <input class="info editable" type="text" placeholder="请输入访客单位" v-model="form.fangkeQiyeName" />
        </div>
        <div class="form-group">
          <label class="label">接访人姓名</label>
          <input class="info editable" type="text" placeholder="请输入接访人姓名" v-model="form.jieFangRenName" />
        </div>
        <div class="form-group">
          <label class="label">接访人手机号</label>
          <input class="info editable" type="tel" placeholder="请输入接访人手机号" v-model="form.jieFangRenPhone" />
        </div>
        <div class="form-group">
          <label class="label">到访时间</label>
          <input class="info editable right-align" type="datetime-local" v-model="form.readTime" />
        </div>
        <div class="form-group">
          <label class="label">到访人数</label>
          <input class="info editable" type="number" placeholder="请输入到访人数" v-model="form.number" />
        </div>
        <div class="form-group">
          <label class="label">到访原因</label>
          <input class="info editable" type="text" placeholder="请输入到访原因" v-model="form.reason" />
        </div>
        <button class="submit-button" @click="submitForm">提交</button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'VisitorForm',
    data() {
      return {
        form: {
          name: '',
          phone: '',
          fangkeQiyeName: '',
          jieFangRenName: '',
          jieFangRenPhone: '',
          readTime: '',
          number: '',
          reason: ''
        }
      };
    },
    methods: {
      submitForm() {
        const errors = [];
        const requiredFields = [
          { label: '访客姓名', field: 'name' },
          { label: '访客手机号', field: 'phone' },
          { label: '访客单位', field: 'fangkeQiyeName' },
          { label: '接访人姓名', field: 'jieFangRenName' },
          { label: '接访人联系方式', field: 'jieFangRenPhone' },
          { label: '到访时间', field: 'readTime' },
          { label: '到访人数', field: 'number' },
          { label: '到访原因', field: 'reason' }
        ];
  
        requiredFields.forEach(field => {
          if (!this.form[field.field] || this.form[field.field].trim() === '') {
            errors.push(`${field.label}不能为空`);
          }
        });
        // 验证手机号格式
        const phoneRegex = /^1[3-9]\d{9}$/;
            if (!phoneRegex.test(this.form.phone)) {
                errors.push('访客手机号格式不正确');
            }
            if (!phoneRegex.test(this.form.jieFangRenPhone)) {
                errors.push('接访人联系方式格式不正确');
            }
          //如果选择的时间小于当前时间
          const now = new Date();
          const selectedTime = new Date(this.form.readTime);
          if(selectedTime<now){
            errors.push('选择的时间必须大于当前时间');
          }
        if (errors.length > 0) {
          alert(errors.join('\n'));
          return;
        }
  
        this.callApi();
      },
      callApi() {
        // console.log('调用API，提交表单数据:', this.form);
        this.$axios.post('/api/qiye/form', this.form)
          .then(response => {
            // console.log('表单提交成功:', response);
            if(response.data.code==0){
                this.$message.success("提交成功");
                this.$router.back()
                this.resetForm();
            }else{
              this.$message.error("提交失败");
            }
            
          })
          .catch(error => {
            console.error('表单提交失败:', error);
          });
      },
      resetForm() {
        this.form = {
            name: '',
          phone: '',
          fangkeQiyeName: '',
          jieFangRenName: '',
          jieFangRenPhone: '',
          readTime: '',
          number: '',
          reason: ''
        };
      }
    }
  };
  </script>
  <style scoped>
  .visitor-system {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #5999fd;
  }
  .visitor-form {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    margin-top: -150px;
    margin-right: 5px;
    margin-left: 5px;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .form-group {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    margin-bottom: -5px;
    border-bottom: 1px dashed #ccc;
  }
  
  .label {
    font-weight: bold;
    margin-top: 7px;
    font-size: 15px;
    flex-shrink: 0; /* 防止内容被压缩 */
  }
  .right-align {
  text-align: right;
}

  .label::before {
    content: '*';
    color: red;
    margin-right: 4px;
  }
  
  .info {
    color: #666;
    flex: 1;
    padding: 8px;
    border: none; /* 移除边框 */
    background-color: transparent; /* 移除背景色 */
    outline: none; /* 移除聚焦时的外框 */
    text-align: right; /* 右对齐 */
    white-space: nowrap; /* 防止文本换行 */
    text-align: right;
  }
  
  .editable:focus {
    border-bottom: 1px solid #007bff; /* 聚焦时的底部边框颜色 */
  }
  
  .submit-button {
    width: 100%;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 18px;
    margin-top: 20px;
    cursor: pointer;
  }
  
  .submit-button:hover {
    background-color: #0056b3;
  }
  
  /* 上面的 */
  .top-top-image {
    position: absolute;
    bottom: 120px; /* 距离底部25px */
    left: 50%; /* 距离左侧50% */
    width: 182px; 
    height: 189px; 
  }
  .background-image {
    position: relative;
    width: 100%; /* 图片宽度为100% */
    height: 50vh; /* 图片高度为视口高度的一半 */
    overflow: hidden; /* 隐藏超出部分 */
  }
  
  .top-image {
    width: 100%;
    height: 100%;
    object-fit: cover;/* 确保图片覆盖整个区域，同时保持图片的宽高比*/
  }
  .welcome-text {
    position: absolute;
    bottom: 250px; /* 距离底部150px */
    left: 20px; /* 距离左侧20px */
    color: white; /* 设置字体颜色为白色 */
    font-size: 24px; /* 设置字体大小 */
    font-weight: bold; /* 设置字体加粗 */
    font-style: italic; /* 设置字体为斜体 */
  }
  
  .dengji {
    position: absolute;
    bottom: 200px; /* 距离底部100px */
    left: 20px; /* 距离左侧20px */
    font-size: 30px; /* 设置字体大小 */
    color: #f4cd4e; /* 设置字体颜色 */
    text-align: left; /* 设置文本对齐方式为左对齐 */
    font-weight: bold; /* 设置字体加粗 */
  }
  </style>